import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'
import { TypeformResponseDefinitionFieldChoice } from '@/api/model/typeform/typeform-response-definition-field-choice'

export class TypeformResponseDefinitionField extends BaseModel<TypeformResponseDefinitionField> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public fieldId: string,
        public fieldTitle: string,
        public fieldType: string,
        public fieldRef: string,
        public choices: TypeformResponseDefinitionFieldChoice[],
        public allowMultipleSelections?: boolean,
        public allowOtherChoice?: boolean,
    ) { super(null) }

    toRequestData(): any {
        return {
            fieldId: this.fieldId,
            fieldTitle: this.fieldTitle,
            fieldType: this.fieldType,
            fieldRef: this.fieldRef,
            choices: this.choices.map(entry => entry.toRequestData()),
            allowMultipleSelections: this.allowMultipleSelections,
            allowOtherChoice: this.allowOtherChoice,
        }
    }

    static fromData(data: any): TypeformResponseDefinitionField {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseDefinitionField) {
            return data
        }

        return new TypeformResponseDefinitionField(
            data.fieldId,
            data.fieldTitle,
            data.fieldType,
            data.fieldRef,
            Object.values(data.choices || {}).map(entry => TypeformResponseDefinitionFieldChoice.fromData(entry)),
            data.allowMultipleSelections,
            data.allowOtherChoice,
        )
    }
}
